export const shopSectionAnchor = (sectionId: number) => `shop-section-${sectionId}`;
